const securityOptions = {
    RequestSignature: '',
    RequestToken: '',
    CustomCodeType: '',
    CustomCode: '',
}

const securityOptionsHeaders = [
    'Firma',
    'Token',
    'Tipo de código de seguridad',
    'Código de Seguridad',
]

const exportOrdersBase = {
    insertionTS: '',
    alias: '',
    depositCode: '',
    mobilePhoneNumber: '',
    mail: '',
    trackingNumber: '',
    orderStateName: '',
    shippingMethod: '',
    cost: '',
    address: '',
    zipCode: '',
    lockerId: '',
    lockerName: '',
    lockerAddress: '',
    doorSizeId: '',
    doorSizeName: '',
    apiWebhookDefinitionId: '',
    depositDate: '',
    collectedDate: '',
    expiredNotCollectedDate: '',
    abandonedCollectedDate: '',
}

const exportOrdersBaseHeaders = [
    'Fecha',
    'Alias',
    'Código de depósito',
    'Teléfono',
    'Email',
    'Número de seguimiento',
    'Estado de la órden',
    'Método de envío',
    'Precio',
    'Dirección de envío',
    'Código postal',
    'Locker ID',
    'Nombre del locker',
    'Dirección del Locker',
    'ID de puerta',
    'Tamaño de puerta',
    'ID Estado Api',
    'Fecha del depósito del paquete en el locker',
    'Fecha del retiro del paquete del locker',
    'Fecha de vencimiento del retiro del paquete',
    'Fecha de recupero del paquete abandonado',
]

const downloadOrdersBase = {
    ClientMail: '',
    ClientName: '',
    ClientPhone: '',
    Alias: '',
    LockerId: '',
    ParcelHeightInMm: '',
    ParcelLengthInMm: '',
    ParcelWidthInMm: '',
    ParcelWeightInGrams: '',
    StreetName: '',
    StreetNumber: '',
    Floor: '',
    City: '',
    CountrySubdivision: '',
    PostalCode: '',
    Apartment: '',
    DepositCode: '',
}

export function downloadOrdersTemplate(orderCustomSecurity) {
    if (orderCustomSecurity) {
        return { ...downloadOrdersBase, ...securityOptions }
    } else {
        return downloadOrdersBase
    }
}

export function exportOrdersTemplate(orderCustomSecurity) {
    if (orderCustomSecurity) {
        return { ...exportOrdersBase, ...securityOptions }
    } else {
        return exportOrdersBase
    }
}

export function exportOrdersHeaders(orderCustomSecurity) {
    if (orderCustomSecurity) {
        return [...exportOrdersBaseHeaders, ...securityOptionsHeaders]
    } else {
        return exportOrdersBaseHeaders
    }
}